import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import ErrorBoundary from "@/components/ErrorBoundary";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import ClientMarquee from "@/components/ClientMarquee";
import Services from "@/components/Services";
import Tools from "@/components/Tools";
import Work from "@/components/Work";
import Stats from "@/components/Stats";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="relative min-h-screen bg-[#070709] text-white">
        <div className="grain" aria-hidden="true" />
        <Nav />
        <main>
          <Hero />
          <ClientMarquee />
          <Services />
          <Tools />
          <Work />
          <Stats />
          <Contact />
        </main>
        <Footer />
      </div>
    </ErrorBoundary>
  );
}

export default App;
